import React from 'react';
import { locales } from '../../../../translations/locales';

const Checkbox = (props) => {
    const { locale, configType, data } = props;

    return (
        <div className='form-check'>
            <input
                className='form-check-input'
                type='checkbox'
                id={configType}
                defaultChecked={`${data && data.authorizations[configType] ? data.authorizations[configType] :
                    data && data.authorizations.admin[configType] ? data.authorizations.admin[configType] :
                        ''}`
                }
            />
            <label className='form-check-label' htmlFor={configType}>
                {locales[locale].auth[configType]}
            </label>
        </div>
    );
};

export default Checkbox;
